// Role model: ONE role per user. Access is by exact role match — there is no
// hierarchy. The Platform Owner is the only role that implicitly sees every
// module (granted in the gating helpers, see Menu.tsx / module-config.tsx).
import type { XRole } from './module-types';

export const allRoles: XRole[] = [
  'platform owner',
  'owner',
  'admin',
  'manager',
  'employee',
  'broker',
];

export const roleLabels: Record<XRole, string> = {
  'platform owner': 'Platform Owner',
  owner: 'Owner',
  admin: 'Admin',
  manager: 'Manager',
  employee: 'Employee',
  broker: 'Broker',
};

/* ---- Per-module role sets (which roles can see a module) ----
 * Platform Owner is added separately in the gating helpers, so it does not
 * need to appear in these lists. */
export const platformOwnerRoles: XRole[] = ['platform owner'];
export const ownerRoles: XRole[] = ['owner'];
export const adminRoles: XRole[] = ['admin'];
export const managerRoles: XRole[] = ['manager'];
export const inventoryRoles: XRole[] = ['owner', 'admin', 'manager'];
export const employeeRoles: XRole[] = ['employee'];
export const brokerRoles: XRole[] = ['broker'];

// Short description of what each role can do (e.g. for a permissions screen).
export const defaultRoleInfoText: Record<XRole, string> = {
  'platform owner': `
    <ul class="list-disc pl-4">
      <li>Owns the platform and can do anything.</li>
      <li>Creates organizations, plans, brokers and oversees revenue.</li>
    </ul>`,
  owner: `
    <ul class="list-disc pl-4">
      <li>Full control of their own organization.</li>
      <li>Manages org settings, team and inventory.</li>
    </ul>`,
  admin: `
    <ul class="list-disc pl-4">
      <li>Manages the organization's inventory and data.</li>
    </ul>`,
  manager: `
    <ul class="list-disc pl-4">
      <li>Manages inventory (products, warehouses, categories, orders).</li>
    </ul>`,
  employee: `
    <ul class="list-disc pl-4">
      <li>Works in the organization; sees only the employee portal.</li>
    </ul>`,
  broker: `
    <ul class="list-disc pl-4">
      <li>Reseller / partner; sees the broker portal and their referred clients.</li>
    </ul>`,
};
